"use strict";
exports.__esModule = true;
exports.RandomColoredChip = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
var utils_1 = require("../utils");
var useChipStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        root: {
            backgroundColor: function (_a) {
                var $backgroundColor = _a.$backgroundColor;
                return $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : 'inherit';
            },
            '&:active, &:focus': {
                background: function (_a) {
                    var $backgroundColor = _a.$backgroundColor;
                    return $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : 'inherit';
                }
            }
        },
        label: {
            color: function (_a) {
                var $textColor = _a.$textColor;
                return $textColor !== null && $textColor !== void 0 ? $textColor : 'inherit';
            }
        },
        clickable: {
            '&:hover': {
                background: function (_a) {
                    var $backgroundColor = _a.$backgroundColor;
                    return $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : 'inherit';
                },
                filter: 'brightness(92%)'
            }
        },
        deletable: {
            '&:hover': {
                background: function (_a) {
                    var $backgroundColor = _a.$backgroundColor;
                    return $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : 'inherit';
                }
            }
        },
        icon: {
            color: function (_a) {
                var $textColor = _a.$textColor;
                return $textColor !== null && $textColor !== void 0 ? $textColor : 'inherit';
            },
            '&:hover': {
                color: function (_a) {
                    var $textColor = _a.$textColor;
                    return $textColor !== null && $textColor !== void 0 ? $textColor : 'inherit';
                }
            }
        },
        deleteIcon: {
            color: function (_a) {
                var $textColor = _a.$textColor;
                return $textColor !== null && $textColor !== void 0 ? $textColor : 'inherit';
            },
            '&:hover': {
                color: function (_a) {
                    var $textColor = _a.$textColor;
                    return $textColor !== null && $textColor !== void 0 ? $textColor : 'inherit';
                }
            }
        }
    });
});
function RandomColoredChip(props) {
    var color = utils_1.getRandomColor(typeof props.label === 'string' ? props.label : '');
    var classes = useChipStyles({
        $backgroundColor: color === null || color === void 0 ? void 0 : color.main,
        $textColor: color === null || color === void 0 ? void 0 : color.contrastText
    });
    return react_1["default"].createElement(core_1.Chip, tslib_1.__assign({}, props, { classes: classes }));
}
exports.RandomColoredChip = RandomColoredChip;
//# sourceMappingURL=RandomColoredChip.js.map